<template>
  <b-row>
    <b-col cols="12">
      <vacancy-add-form />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import vacancyAddForm from './VacancyAddForm.vue'

export default {
  components: {
    BRow,
    BCol,
    vacancyAddForm,
  },
}
</script>

<style lang="scss">
    @import '@core/scss/vue/libs/vue-wizard.scss';
    @import '@core/scss/vue/libs/vue-select.scss';
</style>
